module.exports = __webpack_public_path__ + "img/2025-0516-02-01.31e9238e.png";